class SprintIRCO2 {
	constructor() {
		gpio.uart.open();
	}
	command(cmd) {
		return( new Promise(function(resolve, reject) {
			gpio.uart.onmessage = function(event) {
				var msg = event.data;
				msg = msg.replace("\r", "");
				msg = msg.replace("\n", "");
				//gpio.uart.close();
				resolve(msg);
			}
			gpio.uart.send(cmd+"\r\n");
		}) );
	}
}

export default SprintIRCO2;